import { useRouter } from 'next/router';
import { useMemo } from 'react';
import useFetch from '@hooks/useFetch';

const useContinueWatchingData = () => {
  const {
    query: { goalUID }
  } = useRouter();
  const endpointKey = useMemo(
    () =>
      `v1/uplus/subscription/continue_watching_v3/?goal_uid=${goalUID}&limit=1`,
    [goalUID]
  );
  const { data: previouslyWatchedClasses } = useFetch(endpointKey);
  return previouslyWatchedClasses?.[0];
};

export default useContinueWatchingData;
